import Logo from '../logos/nea';

export default Logo;
